<template>
	<div>
		<Drawer :width='30' :closable="false" v-model="visible">
			<template slot="header">
				<div class="content-left-right-split">
					<div class="title-left">
						<img src="/static/imgs/shangpintiaocan.png" class="jxyd-imgicon" />
						选择规格属性
					</div>
					<div class="title-right">
						<label class="title-right-label" @click="managerType">管理</label>
					</div>
				</div>
			</template>
			<div class="head">
				<Input suffix="ios-search" placeholder="输入名称" v-model="searchVal" />
			</div>
			<div class="body">
				<div class="body-left">
					<div class="body-left-item" v-for="(item,index) in typeList" :key="index"
						:style="{'color': selectedType.title == item.title? '#ff6a7f':'black'}"
						@click="clickType(item)">
						{{item.title}}
					</div>
				</div>
				<div class="body-right">
					<div class="body-right-tool">
						<label class="body-right-tool-label" v-show="!isSelectedAll" @click="selectedAll">全选</label>
						<label class="body-right-tool-label" v-show="isSelectedAll" @click="selectedAll">取消</label>
					</div>
					<div class="body-right-content">
						<div class="body-right-content-item" v-for="(item,index) in getSelectedTypeItem" :key="index"
							:style="getStyleObj(item.title)" @click="clickFormat(item.title)">
							{{item.title}}
						</div>
						<div class="format-list-empty" v-show="getSelectedTypeItem.length<=0">
							<div class="format-list-empty-image">
								<image style="width: 140px;height: 140px;"
									src="https://www.mescroll.com/img/mescroll-empty.png">
								</image>
							</div>
							<div class="format-list-empty-text">空空如也～</div>
						</div>
					</div>
				</div>
			</div>
			<div class="button-container">
				<button class="jxyd-button jxyd-primary" @click="visible = false;">关闭</button>
				<button class="jxyd-button" @click="submitFormatInfo">保存</button>
			</div>
		</Drawer>
		<Modal v-model="formatInfoModal" draggable sticky scrollable>
			<p slot="header" class="layout-title-left">
				<img src="/static/imgs/shangpintiaocan.png" class="jxyd-imgicon" />
				<span> 规格信息管理</span>
			</p>
			<div class="format-modal-content">
				<Tree :data="formatInfoData" ref="formatInfoTree" @on-select-change="clickNode">
				</Tree>
			</div>
			<div slot="footer">
				<button class="jxyd-button jxyd-primary" @click="formatInfoModal = false;">关闭</button>
				<button class="jxyd-button" @click="formatInfoModal = false;">保存</button>
			</div>
		</Modal>
		<Modal v-model="addFormatInfoModal" draggable sticky scrollable>
			<p slot="header" style="text-align:left">
				<Icon type="ios-create-outline" size='18' />
				<span>添加规格信息</span>
			</p>
			<div class="format-modal-content" style="height: auto;">
				<Input placeholder="输入规格名称" v-model="formatInfoItem.key" />
			</div>
			<div slot="footer">
				<button class="jxyd-button jxyd-primary" @click="addFormatInfoModal = false;">关闭</button>
				<button class="jxyd-button" @click="saveFormatInfo">保存</button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'MultiFormatSetting',
		props: {
			// 添加一个控制抽屉显示/隐藏的 prop
			showDrawer: {
				type: Boolean,
				default: false
			},
			selectedFormat: {
				type: String,
				default: ''
			},
			commodityId: {
				type: Number,
				default: 0
			}
		},
		computed: {
			// 使用计算属性来同步 prop 到组件内部状态
			visible: {
				get() {
					return this.showDrawer;
				},
				set(value) {
					// 当抽屉关闭时，触发事件通知父组件
					this.$emit('drawer-change', value);
				}
			},
			getSelectedTypeItem() {
				let data = [];
				if (this.selectedType && this.selectedType.children) {
					for (let i = 0; i < this.selectedType.children.length; i++) {
						if (this.selectedType.children[i].title.indexOf(this.searchVal) > -1) {
							data.push(this.selectedType.children[i]);
						}
					}
				}
				return data;
			}
		},
		created() {
			this.initTreeData();
			setTimeout(() => {
				this.selectedItem = [];
				this.typeList.forEach((item)=>{
					this.selectedItem.push({
						type: item.title,
						items: []
					});
				})
				if (this.selectedFormat) {
					let data = this.convertToSelectedItem(this.selectedFormat, this.typeList);
					for (let i = 0; i < this.selectedItem.length; i++) {
						for (let n = 0; n < data.length; n++) {
							if (this.selectedItem[i].type == data[n].type) {
								this.selectedItem[i].items = data[n].items;
								break;
							}
						}
					}
				}
			}, 300);
		},
		data() {
			return {
				typeList: [],
				searchVal: '',
				selectedType: {},
				selectedItem: [],
				isSelectedAll: false,
				typePid: 'spgg',
				formatInfoData: [],
				formatInfoModal: false,
				addFormatInfoModal: false,
				formatInfoItem: {
					id: 0,
					key: '',
					value: '',
					note: '',
					pid: 0,
					pcode: '',
					creator: 0
				}
			}
		},
		watch: {
			'selectedItem': {
				deep: true,
				handler(array) {
					for (let i = 0; i < array.length; i++) {
						if (array[i].type == this.selectedType.title) {
							this.isSelectedAll = this.selectedType.children.length == array[i].items.length
							return;
						}
					}
					this.isSelectedAll = false;
				}
			},
			'selectedType': {
				deep: true,
				handler(val) {
					for (let i = 0; i < this.selectedItem.length; i++) {
						if (this.selectedItem[i].type == val.title) {
							this.isSelectedAll = val.children.length == this.selectedItem[i].items.length
							return;
						}
					}
					this.isSelectedAll = false;
				}
			}
		},
		methods: {
			clickNode() {
				let treeNode = this.$refs.formatInfoTree.getSelectedNodes();
				if (treeNode.length <= 0) {
					return;
				}
			},
			// 添加一个关闭方法
			closeDrawer() {
				this.$emit('drawer-change', false);
			},
			convertToSelectedItem(paramString, typeListJSON) {
				// 分割参数字符串
				const paramParts = paramString.split(',');

				// 预处理：创建选项到规格类型的映射
				const optionToTypeMap = new Map();
				typeListJSON.forEach(specType => {
					specType.children.forEach(child => {
						optionToTypeMap.set(child.value, specType.value);
					});
				});

				// 预处理：创建规格类型到选项集合的映射
				const typeToOptionsMap = new Map();
				typeListJSON.forEach(specType => {
					const optionSet = new Set();
					specType.children.forEach(child => {
						optionSet.add(child.value);
					});
					typeToOptionsMap.set(specType.value, optionSet);
				});

				// 处理每个参数部分，确定其所属的规格类型
				const partToTypeMap = new Map();
				paramParts.forEach(part => {
					const options = part.split('|');

					// 确定这些选项属于哪个规格类型
					const possibleTypes = new Set();
					options.forEach(option => {
						const type = optionToTypeMap.get(option);
						if (type) possibleTypes.add(type);
					});

					// 如果所有选项都属于同一规格类型，则记录映射关系
					if (possibleTypes.size === 1) {
						const type = Array.from(possibleTypes)[0];
						partToTypeMap.set(part, type);
					}
				});

				// 创建结果数组
				const selectedItem = [];

				// 为每个规格类型收集选项
				const typeToItemsMap = new Map();
				typeListJSON.forEach(specType => {
					typeToItemsMap.set(specType.value, []);
				});

				// 处理每个参数部分
				paramParts.forEach(part => {
					const type = partToTypeMap.get(part);
					if (type) {
						const options = part.split('|');
						const validOptions = options.filter(option => {
							const optionSet = typeToOptionsMap.get(type);
							return optionSet && optionSet.has(option);
						});

						if (validOptions.length > 0) {
							const items = typeToItemsMap.get(type);
							validOptions.forEach(option => {
								if (items.indexOf(option) === -1) {
									items.push(option);
								}
							});
						}
					}
				});

				// 构建最终结果
				typeListJSON.forEach(specType => {
					selectedItem.push({
						type: specType.value,
						items: typeToItemsMap.get(specType.value)
					});
				});

				return selectedItem;
			},
			submitCommodityFormat() {
				let array = [];
				for (let i = 0; i < this.selectedItem.length; i++) {
					if (this.selectedItem[i].items.length > 0) {
						array.push(this.selectedItem[i]);
					}
				}
				uni.$emit('UpCommodityFormat', array);
				uni.navigateBack({
					delta: 1
				});
			},
			initTreeData() {
				request.get('/api/DataDictionary/GetTreeOfDataDictionary', {
					params: {
						code: this.typePid
					}
				}).then(result => {
					if (result.state != 1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败"
						});
						return
					}
					try {
						this.formatInfoData = result.data;
						this.initTreeNode(this.formatInfoData);
						this.typeList = result.data[0].children;
						this.selectedType = result.data[0].children[0];
						this.selectedItem = [];
						this.typeList.forEach((item) => {
							this.selectedItem.push({
								type: item.title,
								items: []
							});
						})
					} catch (error) {}
				}).catch(function(error) {})
			},
			initTreeNode(treeData) {
				for (let i = 0; i < treeData.length; i++) {
					treeData[i].render = (h, {
						root,
						node,
						data
					}) => {
						return h('div', {
							attrs: {
								class: 'content-left-right-split'
							}
						}, [h('div', {
							style: {
								'display': 'flex',
								'height': '22px',
								'line-height': '22px'
							}
						}, [
							h('img', {
								style: {
									'width': '22px',
									'height': '22px'
								},
								attrs: {
									src: "/static/imgs/shangpintiaocan.png"
								}
							}),
							h('span', {
								style: {
									cursor: 'pointer',
									//backgroundColor: node.node.selected ? "rgb(255, 106, 127)" : "transparent"
								},
								attrs: {
									class: `ivu-tree-title`
								},
								on: {
									click: (e) => {
										if (!node.node.selected) {
											this.$refs.formatInfoTree.handleSelect(node
												.nodeKey);
										}
									}
								}
							}), data.title
						]), h('div', {}, [h('Icon', {
							attrs: {
								'type': 'md-add-circle',
								'size': '24',
								'color': '#ff6a7f'
							},
							style: {
								'margin-right': '10px'
							},
							on: {
								click: (e) => {
									if (!node.node.selected) {
										this.$refs.formatInfoTree.handleSelect(node
											.nodeKey);

										if (node.node.path.split(',').length >= 4) {
											this.$Notice.error({
												title: '错误提示',
												duration: 3,
												desc: '仅能创建两层节点'
											});
											return
										}

										this.formatInfoItem.pcode = node.node.value;
										this.addFormatInfoModal = true;
									}
								}
							}
						}), h('Icon', {
							attrs: {
								'type': 'ios-remove-circle-outline',
								'size': '24'
							},
							style: {
								'margin-right': '20px'
							},
							on: {
								click: (e) => {
									if (!node.node.selected) {
										this.$refs.formatInfoTree.handleSelect(node
											.nodeKey);
										this.deleFormatInfo(node.node);
									}
								}
							}
						})])]);

					};
					if (treeData[i].children && treeData[i].children.length > 0) {
						this.initTreeNode(treeData[i].children);
					}
				}
			},
			doCheckAdd() {
				let types = [];
				let currentItems = [];
				for (let n = 0; n < this.selectedItem.length; n++) {
					if (this.selectedItem[n].items.length > 1) {
						types.push(this.selectedItem[n].type);
					}
					if (this.selectedItem[n].type == this.selectedType.title) {
						currentItems = this.selectedItem[n].items;
					}
					if (types.indexOf(this.selectedType.title) <= -1) {
						if (types.length > 2) {
							this.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "最多允许两种属性多选，其它仅能单选"
							});
							return false;
						}
						if (types.length == 2 && currentItems.length >= 1) {
							this.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "最多允许两种属性多选，其它仅能单选"
							});
							return false;
						}
					}
				}
				return true;
			},
			async doCheckRemove(param) {
				let result1 = true;
				try {
					let result = await request.get('/api/Commodity/GetStockByFormat', {
						params: {
							commodityId: this.commodityId,
							format: param
						}
					});
					if (result.state != 1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "通过商品规格获取库存失败"
						});
						return;
					}
					result1 = result.data <= 0;
				} catch (error) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "通过商品规格获取库存失败"
					});
				}
				return result1;
			},
			clickFormat(item) {
				for (let i = 0; i < this.selectedItem.length; i++) {
					if (this.selectedItem[i].type == this.selectedType.title) {
						let index = this.selectedItem[i].items.indexOf(item);
						if (index > -1) {
							this.selectedItem[i].items.splice(index, 1);
						} else {
							if (!this.doCheckAdd()) {
								return;
							}
							this.selectedItem[i].items.push(item);
						}
						return;
					}
				}
			},
			clickType(type) {
				this.selectedType = type;
			},
			isSelectedItem(item) {
				for (let i = 0; i < this.selectedItem.length; i++) {
					if (this.selectedItem[i].type == this.selectedType.title) {
						return this.selectedItem[i].items.indexOf(item) > -1;
					}
				}
			},
			getStyleObj(item) {
				if (this.isSelectedItem(item)) {
					return {
						'border': '2px solid #ff6a7f',
						'background-color': '#ff6a7f',
						'color': 'white'
					};
				} else {
					return {
						'border': '2px solid #ff6a7f',
						'background-color': 'white',
						'color': 'black'
					};
				}
			},
			managerType() {
				this.formatInfoModal = true;
			},
			doCheckSelectedAll() {
				let types = [];
				for (let n = 0; n < this.selectedItem.length; n++) {
					if (this.selectedItem[n].items.length > 1) {
						types.push(this.selectedItem[n].type);
					}
					if (types.indexOf(this.selectedType.title) <= -1) {
						if (types.length > 1) {
							this.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "最多允许两种属性多选，其它仅能单选"
							});
							return false;
						}
					}
				}
				return true;
			},
			selectedAll() {
				for (let i = 0; i < this.selectedItem.length; i++) {
					if (this.selectedItem[i].type == this.selectedType.title) {
						if (this.selectedType.children.length != this.selectedItem[i].items.length) {
							if (!this.doCheckSelectedAll()) {
								return;
							}
							this.selectedItem[i].items = [];
							for (let n = 0; n < this.selectedType.children.length; n++) {
								this.selectedItem[i].items.push(this.selectedType.children[n].title);
							}
						} else {
							this.selectedItem[i].items = [];
						}
						return;
					}
				}
				if (!this.doCheckSelectedAll()) {
					return;
				}
				let array = [];
				for (let n = 0; n < this.selectedType.children.length; n++) {
					array.push(this.selectedType.children[n].title);
				}
				this.selectedItem.push({
					type: this.selectedType.title,
					items: array
				});
			},
			saveFormatInfo() {
				if (!this.formatInfoItem.key) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请输入要添加的规格信息"
					});
					return;
				}
				this.formatInfoItem.value = this.formatInfoItem.key;
				request.post('/api/DataDictionary/AddDataDictionary', this.formatInfoItem).then(result => {
					if (result.state != 1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: result.errorMsg
						});
						return
					}
					this.formatInfoItem.key = '';
					this.initTreeData();
				}).catch(err => {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "保存失败"
					});
				})
			},
			countChar(str, char) {
				let count = 0;
				for (let i = 0; i < str.length; i++) {
					if (str[i] === char) {
						count++
					}
				}
				return count
			},
			deleFormatInfo(selectedNode) {
				if (selectedNode.children && selectedNode.children.length > 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "该种类下还维护着子种类"
					});
					return
				}
				if (this.countChar(selectedNode.path, ',') <= 1) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "根结点不可删除"
					});
					return
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/DataDictionary/DeleDataDictionary', [selectedNode.id]).then(result => {
							if (result.state != 1) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "删除失败"
								});
								return
							}
							self.initTreeData();
						}).catch(err => {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "删除失败"
							});
						})
					},
					onCancel() {}
				});
			},
			submitFormatInfo(){
				let array = [];
				for (let i = 0; i < this.selectedItem.length; i++) {
					if (this.selectedItem[i].items.length > 0) {
						array.push(this.selectedItem[i]);
					}
				}
				this.$emit('up-commodity-format', array);
				this.visible = false;
			}
		},
	}
</script>

<style scoped>
	.head {
		margin-bottom: 30px;
	}

	.body {
		overflow: hidden;
	}

	.body-left {
		width: 30%;
		float: left;
	}

	.body-left-item {
		text-align: center;
	}

	.body-left-item+.body-left-item {
		padding-top: 15px;
	}

	.body-right {
		width: 70%;
		float: right;
		background-color: white;
	}

	.body-right-tool-label {
		cursor: pointer;
		margin-bottom: 5px;
	}

	.body-right-tool :hover {
		color: #ff6a7f;
		text-decoration: underline;
	}

	.body-right-content {
		overflow: hidden;
	}

	.body-right-content-item {
		float: left;
		margin: 5px;
		padding: 10px;
		border-radius: 20%;
		cursor: pointer;
	}

	.body-right-tool {
		border-bottom: 1px solid gainsboro;
		margin-bottom: 10px;
		display: flex;
		justify-content: flex-end;
	}

	.format-list-empty {
		box-sizing: border-box;
		width: 100%;
		padding: 70px 25px;
		text-align: center;
	}

	.format-list-empty-image {
		width: 100%;
		display: flex;
		text-align: center;
		justify-content: center;
	}

	.format-list-empty-text {
		text-align: center;
		color: rgb(204, 215, 220);
	}

	.body-left-item {
		cursor: pointer;
	}

	.title-left {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 20px;
		line-height: 20px;
		font-size: 16px;
		color: #17233d;
		font-weight: 500;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.title-right:hover {
		color: #ff6a7f;
		text-decoration: underline;
	}

	.format-modal-content {
		width: 100%;
		padding: 10px;
		background-color: #fff;
		border-radius: 5px;
		height: 500px;
		overflow: auto;
	}

	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	/deep/ .ivu-tree-title {
		width: 100%;
	}

	.layout-title-left {
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.button-container {
		width: 100%;
		position: fixed;
		bottom: 10px;
		z-index: 6;
	}
	.button-container button{
		margin-right: 15px;
	}
</style>